<div class="season-form-page">
    <div class="btn-back-detail" (click)="cancel()">
        <i class="fal fa-arrow-left"></i>
        <span>Ver todas las temporadas</span>
    </div>

    <div *ngIf="!loaded" class="loading-container">
        <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
            containerClass="loading-box"></ng-lottie>
    </div>

    <form *ngIf="loaded" [formGroup]="form" (ngSubmit)="save()" class="form-layout">
        <!-- Left column: Form -->
        <div class="form-column">
            <div class="form-card">
                <div class="card-header">
                    <i class="fal fa-id-card card-icon"></i>
                    <div>
                        <h2>Datos de la temporada</h2>
                        <p class="card-subtitle">Nombre, descripción y vigencia</p>
                    </div>
                </div>

                <div class="form-field">
                    <label class="field-label">NOMBRE</label>
                    <input type="text" formControlName="name" placeholder="Ej: Temporada 2026/2027">
                </div>

                <div class="form-field" style="margin-top: 16px;">
                    <label class="field-label">DESCRIPCIÓN</label>
                    <textarea formControlName="description" rows="3" placeholder="Descripción opcional"></textarea>
                </div>

                <div class="form-grid-2" style="margin-top: 16px;">
                    <div class="form-field">
                        <label class="field-label">FECHA DE INICIO</label>
                        <app-date-field formControlName="start_date"></app-date-field>
                    </div>
                    <div class="form-field">
                        <label class="field-label">FECHA DE FIN</label>
                        <app-date-field formControlName="end_date"></app-date-field>
                    </div>
                </div>
                <span class="field-hint" *ngIf="form.errors?.['dateRange']">
                    <i class="fal fa-info-circle"></i> La fecha de fin no puede ser anterior a la de inicio
                </span>
            </div>

            <div class="form-card" *ngIf="isEdit">
                <div class="card-header">
                    <i class="fal fa-cart-shopping card-icon"></i>
                    <div>
                        <h2>Productos por categoría y nivel</h2>
                        <p class="card-subtitle">Qué abono paga cada abonado según su categoría y el nivel de su butaca</p>
                    </div>
                </div>

                <p class="field-hint" *ngIf="products.length === 0">
                    <i class="fal fa-info-circle"></i>
                    No hay productos creados todavía. Créalos desde la pestaña Productos, uno por
                    cada combinación de categoría, nivel y variante (con y sin carnet físico).
                </p>

                <ng-container *ngIf="products.length > 0">
                    <div class="form-field" *ngIf="spaces.length > 1">
                        <label class="field-label">RECINTO</label>
                        <select class="native-select" [ngModel]="selectedSpaceId" [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="onSpaceChange($event)">
                            <option [ngValue]="null">Selecciona un recinto para ver sus niveles</option>
                            <option *ngFor="let s of spaces" [ngValue]="s.id">{{s.name}}</option>
                        </select>
                    </div>

                    <div class="levels-loading" *ngIf="levelsLoading">
                        <i class="fal fa-spinner-third fa-spin"></i> Cargando niveles del recinto...
                    </div>

                    <div class="assignment-category" *ngFor="let cat of categories">
                        <h3 class="assignment-category-title">{{cat.name}}</h3>

                        <div class="assignment-row" *ngFor="let level of levelRows">
                            <div class="assignment-level">
                                <span class="assignment-level-name">{{level.name}}</span>
                                <span class="assignment-level-hint" *ngIf="level.id === null">
                                    Se aplica a cualquier nivel
                                </span>
                            </div>

                            <div class="assignment-products">
                                <span class="assignment-chip" *ngFor="let p of productsIn(cat.id, level.id)"
                                    [class.admin-only]="p.admin_only">
                                    <i class="fal fa-lock assignment-chip-lock" *ngIf="p.admin_only"
                                        title="Solo panel: no aparece en el alta ni en la renovación web"></i>
                                    <span class="assignment-chip-name">{{p.name}}</span>
                                    <span class="assignment-chip-price">{{p.price | number:'1.2-2'}} €</span>
                                    <i class="fal fa-xmark" (click)="removeAssignment(cat.id, level.id, p.id)"></i>
                                </span>

                                <select class="native-select assignment-add" #addSelect
                                    (change)="addAssignment(cat.id, level.id, addSelect.value); addSelect.value = ''">
                                    <option value="">+ Añadir producto</option>
                                    <option *ngFor="let p of productsAvailableIn(cat.id, level.id)" [value]="p.id">
                                        {{p.name}} — {{p.price | number:'1.2-2'}} €{{ p.admin_only ? ' · Solo panel' : '' }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <p class="field-hint" *ngIf="hiddenAssignmentsCount > 0">
                        <i class="fal fa-info-circle"></i>
                        Hay {{hiddenAssignmentsCount}} asignación(es) de niveles de otro recinto o de una
                        versión anterior del mapa. No se muestran aquí, pero se conservan al guardar.
                    </p>
                </ng-container>
            </div>

            <div class="form-card" *ngIf="!isEdit">
                <div class="card-header">
                    <i class="fal fa-cart-shopping card-icon"></i>
                    <div>
                        <h2>Productos por categoría y nivel</h2>
                        <p class="card-subtitle">Disponible al guardar la temporada</p>
                    </div>
                </div>
                <p class="field-hint">
                    <i class="fal fa-info-circle"></i>
                    Crea primero la temporada y podrás asignar aquí qué abono paga cada categoría
                    en cada nivel de butaca.
                </p>
            </div>
        </div>

        <!-- Right column: Actions -->
        <div class="preview-column">
            <div class="active-toggle-bar" *ngIf="isEdit" [class.active]="form.get('active')?.value">
                <div class="active-toggle-info">
                    <i class="fal" [ngClass]="form.get('active')?.value ? 'fa-circle-check' : 'fa-circle-xmark'"></i>
                    <div>
                        <span class="active-toggle-label">{{ form.get('active')?.value ? 'Temporada activa' : 'Temporada inactiva' }}</span>
                        <span class="active-toggle-hint">{{ form.get('active')?.value ? 'Visible para dar de alta abonos' : 'No se pueden dar de alta nuevos abonos' }}</span>
                    </div>
                </div>
                <mat-slide-toggle class="toggle-pink" formControlName="active"></mat-slide-toggle>
            </div>

            <div class="form-actions">
                <button type="submit" class="btn-save" [disabled]="form.invalid || saving">
                    <i class="fal" [ngClass]="saving ? 'fa-spinner-third fa-spin' : 'fa-floppy-disk'"></i>
                    {{ saving ? 'Guardando...' : (isEdit ? 'Guardar cambios' : 'Crear temporada') }}
                </button>
                <button type="button" class="btn-cancel" (click)="cancel()">
                    Cancelar
                </button>
            </div>
        </div>
    </form>
</div>
